const LoadingSkeletonModalTable = () => {
	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full py-2"
			data-test="loading-skeleton-table"
		>
			<div className="bg-gray-200 h-4 w-16 rounded py-2"></div>
			<div className="w-full overflow-x-auto">
				<table className="w-full">
					<thead>
						<tr className="border-b text-gray-800 uppercase">
							<th className="px-6 py-3 text-left text-xs font-medium tracking-wider">
								<div className="bg-gray-200 h-4 w-14 rounded"></div>
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium tracking-wider">
								<div className="bg-gray-200 h-4 w-20 rounded"></div>
							</th>
							<th className="px-6 py-3 text-left text-xs font-medium tracking-wider">
								<div className="bg-gray-200 h-4 w-24 rounded"></div>
							</th>
						</tr>
					</thead>
					<tbody className="bg-white divide-y divide-gray-200">
						{[...Array(3)].map((_, index) => (
							<tr key={index} className="animate-pulse">
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="bg-gray-200 px-4 pt-[8px] pb-[18px] w-1/4 rounded"></div>
								</td>
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="bg-gray-200 px-4 pt-[8px] pb-[18px] w-3/4 rounded"></div>
								</td>
								<td className="px-6 py-4 whitespace-nowrap">
									<div className="bg-gray-200 px-4 pt-[8px] pb-[18px] w-1/2 rounded"></div>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
			<div className="flex sm:flex-row flex-col w-full items-center justify-between gap-2 px-4  ">
				<div className="bg-gray-200 h-6 w-full rounded"></div>
			</div>
		</div>
	);
};

export default LoadingSkeletonModalTable;
